<template>
    <div>
        <div class="footer">
            <div class="wrap">
                <div class="footer_left">
                    <div class="footer_nav">
                        <div class="li" :class="index_on==1?'on':''" @click="index_on=(index_on==1?0:1)"><div class="p1">主要业务</div></div>
                        <div class="ul pc">
                            <router-link :to="{path:'/lease'}" class="li" :class="path=='lease'?'on':''">房产租赁</router-link>
                            <router-link :to="{path:'/business'}" class="li" :class="path=='business'?'on':''">房产买卖</router-link>
                            <router-link :to="{path:'/entrust'}" class="li" :class="path=='entrust'?'on':''">委托管理</router-link>
                        </div>
                        <div class="ul wap" v-show="index_on==1">
                            <router-link :to="{path:'/lease'}" class="li" :class="path=='lease'?'on':''">房产租赁</router-link>
                            <router-link :to="{path:'/business'}" class="li" :class="path=='business'?'on':''">房产买卖</router-link>
                            <router-link :to="{path:'/entrust'}" class="li" :class="path=='entrust'?'on':''">委托管理</router-link>
                        </div>
                    </div>
                    <div class="footer_nav">
                        <div class="li" :class="index_on==2?'on':''" @click="index_on=(index_on==2?0:2)"><div class="p1">其他业务</div></div>
                        <div class="ul pc">
                            <router-link :to="{path:'/renovation'}" class="li" :class="path=='renovation'?'on':''">装修业务</router-link>
                            <router-link :to="{path:'/move'}" class="li" :class="path=='move'?'on':''">搬家业务</router-link>
                        </div>
                        <div class="ul wap" v-show="index_on==2">
                            <router-link :to="{path:'/renovation'}" class="li" :class="path=='renovation'?'on':''">装修业务</router-link>
                            <router-link :to="{path:'/move'}" class="li" :class="path=='move'?'on':''">搬家业务</router-link>
                        </div>
                    </div>
                    <div class="footer_nav">
                        <div class="li" :class="index_on==3?'on':''" @click="index_on=(index_on==3?0:3)"><div class="p1">新闻中心</div></div>
                        <div class="ul pc">
                            <router-link :to="{path:'/news',query:{type:'1'}}" class="li" :class="path=='news'?'on':''">全部新闻</router-link>
                        </div>
                        <div class="ul wap" v-show="index_on==3">
                            <router-link :to="{path:'/news',query:{type:'1'}}" class="li" :class="path=='news'?'on':''">全部新闻</router-link>
                        </div>
                    </div>
                    <div class="footer_nav">
                        <div class="li" :class="index_on==4?'on':''" @click="index_on=(index_on==4?0:4)"><div class="p1">招聘信息</div></div>
                        <div class="ul pc">
                            <router-link :to="{path:'/recruit_info',query:{id:item.id}}" class="li" v-for="(item,index) in list" :key="index+'a'">{{item.title}}</router-link>
                        </div>
                        <div class="ul wap" v-show="index_on==4">
                            <router-link :to="{path:'/recruit_info',query:{id:item.id}}" class="li" v-for="(item,index) in list" :key="index+'b'">{{item.title}}</router-link>
                        </div>
                    </div>
                    <div class="footer_nav">
                        <div class="li" :class="index_on==5?'on':''" @click="index_on=(index_on==5?0:5)"><div class="p1">关于我们</div></div>
                        <div class="ul pc">
                            <router-link :to="{path:'/about#summary'}" class="li">公司概要</router-link>
                            <router-link :to="{path:'/about#history'}" class="li">公司历史</router-link>
                            <router-link :to="{path:'/contact'}" class="li">联系我们</router-link>
                        </div>
                        <div class="ul wap" v-show="index_on==5">
                            <router-link :to="{path:'/about#summary'}" class="li">公司概要</router-link>
                            <router-link :to="{path:'/about#history'}" class="li">公司历史</router-link>
                            <router-link :to="{path:'/contact'}" class="li">联系我们</router-link>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="p1">联系电话：{{info.title1}}</div>
                    <div class="p1">地址：{{info.title4}}</div>
                </div>
                <div class="erweim_kuang">
                    <div class="li">
                        <img :src="info.qr1_url" alt="">
                        <div class="p1">微信二维码</div>
                    </div>
                    <div class="li">
                        <img :src="info.qr2_url" alt="">
                        <div class="p1">LINE二维码</div>
                    </div>
                </div>
            </div>
            <div class="copyright">Copyright © 2020-2023 株式会社House Plus All Rights Reserved.</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'header_html',
    data () {
        return {
            index_on:0,
            wap_nav:false,
            path:this.$route.path,
            info:{},
            list:[],
        }
    },
    // 初始事件
    mounted: function () {
        this.getInfo();
        this.job_list();
    },
    // 事件
    methods: {
        // 初始化
        getInfo() {
            var this_ = this;
            var url = "index/getDetail";
            var datas={
                module_name:'contact'
            }
            this_.$post(url,datas).then((res) => {
                this_.info = res;
                document.title=res.title;
            })
        },
        job_list() {
            var this_ = this;
            var url = "index/job_list";
            var datas = {
                page: 1,
                num: 3,
            };
            this_.$post(url, datas).then((res) => {
                this_.list = res.list;
            })
        },
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/footer_html.vue